import React from "react";
import {Box, Button, CircularProgress, IconButton, Stack, Tooltip, Typography} from "@mui/material";
import {HugeiconsIcon} from "@hugeicons/react";
import {Call02Icon, ViewIcon} from "@hugeicons/core-free-icons";
import {useWebrtc} from "../../context/WebrtcContext";
import {useRegistryProject} from "../../pages/registry-project/RegistryProjectContext";
import {formatTime} from "../../utils/functions";

const Message = ({children}) => (
  <Typography sx={{py: 5, px: 3, textAlign: "center", fontSize: 13, color: "#8A8AA0"}}>{children}</Typography>
);

// The callers waiting in the project's agent groups, longest wait first. queue: see useAgentQueue. A caller without a
// conversation cannot be taken from here, only answered when the group rings this browser.
export const PhoneQueueTab = ({queue, onOpenConversation}) => {
  const {project} = useRegistryProject();
  const {status, call, takeOverCall} = useWebrtc();
  const {groups, waiting, unavailable} = queue;
  const canCall = status === "registered" && !call;

  if (groups === null) return <Box sx={{display: "flex", justifyContent: "center", py: 5}}><CircularProgress size={20}/></Box>;
  if (groups.length === 0) return <Message>This project has no agent groups, so no calls can wait here.</Message>;
  if (unavailable) return <Message>The queue cannot be read while Asterisk is unreachable.</Message>;
  if (waiting.length === 0) return <Message>Nobody is waiting</Message>;

  return (
    <Box sx={{flex: 1, minHeight: 0, overflowY: "auto", px: 1, py: 0.5}}>
      {waiting.map(caller => (
        <Stack
          key={`${caller.group.id}-${caller.channel || caller.position}`} direction={"row"} alignItems={"center"} gap={1}
          sx={{px: 1, py: 1.25, borderBottom: "1px solid #F2F2F7"}}
        >
          <Box sx={{flex: 1, minWidth: 0}}>
            <Typography noWrap sx={{fontSize: 14, fontWeight: 600, color: "#23264D"}}>{caller.caller_id || "Unknown"}</Typography>
            <Typography noWrap sx={{fontSize: 12, color: "#8A8AA0"}}>#{caller.position} in {caller.group.name}</Typography>
          </Box>
          <Typography sx={{fontSize: 12, fontWeight: 600, color: "#A86A0C", fontVariantNumeric: "tabular-nums"}}>
            {formatTime(caller.wait_seconds || 0)}
          </Typography>
          {caller.conversation_id && (
            <>
              <Tooltip title={"View conversation"}>
                <IconButton
                  aria-label={"View conversation"} size={"small"} sx={{color: "#4B55C9"}}
                  onClick={() => onOpenConversation(caller.conversation_id)}
                >
                  <HugeiconsIcon icon={ViewIcon} size={18}/>
                </IconButton>
              </Tooltip>
              <Button
                disabled={!canCall} startIcon={<HugeiconsIcon icon={Call02Icon} size={15}/>}
                onClick={() => takeOverCall({projectId: project?.id, conversationId: caller.conversation_id})}
                sx={{
                  height: 30, px: 1.25, borderRadius: "9px", textTransform: "none", fontSize: 12, fontWeight: 600,
                  color: "#1E8A55", bgcolor: "#E8F7EF", "&:hover": {bgcolor: "#D9F2E4"},
                }}
              >
                Take
              </Button>
            </>
          )}
        </Stack>
      ))}
    </Box>
  );
};
